"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _themeMapper = require("@gravity/theme-mapper");
var _themeProvider = require("@gravity/theme-provider");
var _utils = require("@gravity/utils");
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _polished = require("polished");
var _jsxFileName = "/codebuild/output/src1825986617/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/RangeSlider/lib/Handle.js",
  _templateObject,
  _templateObject2,
  _templateObject3,
  _templateObject4,
  _this = void 0;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function cov_27l5logu5d() {
  var path = "/codebuild/output/src1825986617/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/RangeSlider/lib/Handle.js";
  var hash = "3a8894789e5f34579c1a1084a0a869914a71daf2";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src1825986617/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/RangeSlider/lib/Handle.js",
    statementMap: {
      "0": {
        start: {
          line: 8,
          column: 16
        },
        end: {
          line: 90,
          column: 1
        }
      },
      "1": {
        start: {
          line: 16,
          column: 33
        },
        end: {
          line: 16,
          column: 89
        }
      },
      "2": {
        start: {
          line: 43,
          column: 33
        },
        end: {
          line: 43,
          column: 89
        }
      },
      "3": {
        start: {
          line: 51,
          column: 31
        },
        end: {
          line: 51,
          column: 60
        }
      },
      "4": {
        start: {
          line: 52,
          column: 10
        },
        end: {
          line: 54,
          column: 13
        }
      },
      "5": {
        start: {
          line: 80,
          column: 8
        },
        end: {
          line: 83,
          column: 9
        }
      },
      "6": {
        start: {
          line: 92,
          column: 15
        },
        end: {
          line: 92,
          column: 46
        }
      },
      "7": {
        start: {
          line: 92,
          column: 24
        },
        end: {
          line: 92,
          column: 46
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 16,
            column: 22
          },
          end: {
            line: 16,
            column: 23
          }
        },
        loc: {
          start: {
            line: 16,
            column: 33
          },
          end: {
            line: 16,
            column: 89
          }
        },
        line: 16
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 43,
            column: 22
          },
          end: {
            line: 43,
            column: 23
          }
        },
        loc: {
          start: {
            line: 43,
            column: 33
          },
          end: {
            line: 43,
            column: 89
          }
        },
        line: 43
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 50,
            column: 10
          },
          end: {
            line: 50,
            column: 11
          }
        },
        loc: {
          start: {
            line: 50,
            column: 23
          },
          end: {
            line: 55,
            column: 11
          }
        },
        line: 50
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 79,
            column: 8
          },
          end: {
            line: 79,
            column: 9
          }
        },
        loc: {
          start: {
            line: 80,
            column: 8
          },
          end: {
            line: 83,
            column: 9
          }
        },
        line: 80
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 92,
            column: 15
          },
          end: {
            line: 92,
            column: 16
          }
        },
        loc: {
          start: {
            line: 92,
            column: 24
          },
          end: {
            line: 92,
            column: 46
          }
        },
        line: 92
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 16,
            column: 33
          },
          end: {
            line: 16,
            column: 89
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 16,
            column: 33
          },
          end: {
            line: 16,
            column: 51
          }
        }, {
          start: {
            line: 16,
            column: 55
          },
          end: {
            line: 16,
            column: 89
          }
        }],
        line: 16
      },
      "1": {
        loc: {
          start: {
            line: 43,
            column: 33
          },
          end: {
            line: 43,
            column: 89
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 43,
            column: 33
          },
          end: {
            line: 43,
            column: 51
          }
        }, {
          start: {
            line: 43,
            column: 55
          },
          end: {
            line: 43,
            column: 89
          }
        }],
        line: 43
      },
      "2": {
        loc: {
          start: {
            line: 80,
            column: 8
          },
          end: {
            line: 83,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 80,
            column: 8
          },
          end: {
            line: 80,
            column: 17
          }
        }, {
          start: {
            line: 81,
            column: 8
          },
          end: {
            line: 83,
            column: 9
          }
        }],
        line: 80
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "3a8894789e5f34579c1a1084a0a869914a71daf2"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_27l5logu5d = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_27l5logu5d();
var Wrapper = (cov_27l5logu5d().s[0]++, (0, _utils.withThemedStyles)(_styledComponents.default.span.attrs({
  className: "g-Handle-wrapper"
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n      opacity: 0.9;\n      background-color: white;\n      border-color: ", ";\n      border-width: 1px;\n      border-style: solid;\n      outline: none;\n      position: absolute;\n      top: -7px;\n      margin-left: -5px;\n      z-index: 2;\n      width: 15px;\n      height: 15px;\n      cursor: pointer;\n      border-radius: 50%;\n      &:hover {\n        box-shadow: 0px 0px 0px 8px rgba(144, 202, 249, 0.16);\n      }\n      &::after {\n        top: -15px;\n        left: -15px;\n        right: -15px;\n        bottom: -15px;\n        content: '';\n        position: absolute;\n        border-radius: 50%;\n      }\n    "])), function (props) {
  cov_27l5logu5d().f[0]++;
  cov_27l5logu5d().s[1]++;
  return (cov_27l5logu5d().b[0][0]++, props.theme.button) && (cov_27l5logu5d().b[0][1]++, props.theme.button.backgroundColor);
})), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n      opacity: 0.9;\n      border-color: ", ";\n      outline: none;\n      position: absolute;\n      top: -10px;\n      z-index: 2;\n      cursor: pointer;\n      &:hover {\n        ", "\n      }\n      &::after {\n        top: -15px;\n        left: -15px;\n        right: -15px;\n        bottom: -15px;\n        content: '';\n        position: absolute;\n        border-radius: 50%;\n      }\n      --borderSize: calc(", " * 2);\n      --bulletSize: calc(", " + var(--borderSize));\n      width: ", ";\n      height: ", ";\n      border-style: ", ";\n      border-color: var(--primaryColor, #2f2b43);\n      border-width: ", ";\n      background-color: var(--primaryColor, #2f2b43);\n      border-radius: ", ";\n      margin-left: calc(var(--bulletSize) / -2);\n      box-shadow: none;\n\n      ", ";\n\n      ::after {\n        border-radius: ", ";\n      }\n    "])), function (props) {
  cov_27l5logu5d().f[1]++;
  cov_27l5logu5d().s[2]++;
  return (cov_27l5logu5d().b[1][0]++, props.theme.button) && (cov_27l5logu5d().b[1][1]++, props.theme.button.backgroundColor);
}, function (_ref) {
  var theme = _ref.theme;
  cov_27l5logu5d().f[2]++;
  var opacityColor = (cov_27l5logu5d().s[3]++, (0, _polished.rgba)(theme.primaryColor, 0.1));
  cov_27l5logu5d().s[4]++;
  return (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n              box-shadow: 0px 0px 0px 8px ", ";\n            "])), opacityColor);
}, _themeMapper.evolutionTheme.priceRange.bullet.borderWidth, _themeMapper.evolutionTheme.priceRange.bullet.size, _themeMapper.evolutionTheme.priceRange.bullet.size, _themeMapper.evolutionTheme.priceRange.bullet.size, _themeMapper.evolutionTheme.priceRange.bullet.borderStyle, _themeMapper.evolutionTheme.priceRange.bullet.borderWidth, _themeMapper.evolutionTheme.priceRange.bullet.borderRadius, function (_ref2) {
  var isSliding = _ref2.isSliding;
  cov_27l5logu5d().f[3]++;
  cov_27l5logu5d().s[5]++;
  return (cov_27l5logu5d().b[2][0]++, isSliding) && (cov_27l5logu5d().b[2][1]++, (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n          outline: ", ";\n        "])), _themeMapper.evolutionTheme.priceRange.bullet.pressed.outline));
}, _themeMapper.evolutionTheme.priceRange.bullet.borderRadius))));
cov_27l5logu5d().s[6]++;
var Handle = function Handle(props) {
  cov_27l5logu5d().f[4]++;
  cov_27l5logu5d().s[7]++;
  return /*#__PURE__*/_react.default.createElement(Wrapper, (0, _extends2.default)({}, props, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 92,
      columnNumber: 25
    }
  }));
};
var _default = exports.default = Handle;